// src/MuiTheme.js
import { createTheme } from '@mui/material/styles';
import lightTheme from './LightTheme';
import darkTheme from './DarkTheme';

const muiLightTheme = createTheme({
    palette: {
        mode: 'light',
        background: {
            default: lightTheme.colors.background,
        },
        primary: {
            main: lightTheme.colors.primary,
        },
        secondary: {
            main: lightTheme.colors.secondary,
        },
        text:{
            main: lightTheme.colors.text,
            secondary: lightTheme.colors.text
        }
    },
    typography: {
        fontFamily: lightTheme.fonts.primary,
    },
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
                input: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
                input: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
    },
});

const muiDarkTheme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: darkTheme.colors.background,
            paper: darkTheme.colors.primary,
        },
        primary: {
            main: darkTheme.colors.primary,
        },
        secondary: {
            main: darkTheme.colors.secondary,
        },
        text:{
            main: lightTheme.colors.text,
            secondary: lightTheme.colors.text
        }
    },
    typography: {
        fontFamily: darkTheme.fonts.primary,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: darkTheme.colors.primary,
                    backgroundImage: 'none',
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: darkTheme.colors.primary,
                    backgroundImage: 'none',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
                input: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
                input: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '1rem', // Minimum 16px to prevent iOS zoom
                },
            },
        },
    },
});

export { muiLightTheme, muiDarkTheme };
